var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 894.244,
    height: 448.282,
    viewBox: "0 0 894.244 448.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_contact_us_re_4qqt",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_125",
    "data-name": "Trac\\xE9 125",
    d: "M447.37,674.141q-40.475,0-80.829-1.449c-38.44-1.381-78.19-2.808-115.136-23.3-25.845-14.333-48.735-37.329-66.194-66.5a223.77,223.77,0,0,1-25.369-63.6,261.476,261.476,0,0,1,.953-123.779,219.835,219.835,0,0,1,14.741-40.4c26.943-55.793,76.085-93.246,134.826-102.754a6.808,6.808,0,0,1,1.463-.031c.264.014.527.029.8.018l.346-.11a16.883,16.883,0,0,1,2.721-.7c90.594-13.487,186.365,13.8,276.952,78.914,70.042,50.351,162.868,77.464,283.781,82.889l1.717.09c33.66,1.934,66.218,15.811,94.16,40.133,27.579,24.006,48.287,56.034,59.884,92.624,1.426,4.461,2.733,9.1,3.884,13.8a26.039,26.039,0,0,1-6.941,24.69v.009l-.3.31c-.725.721-1.488,1.412-2.267,2.056l-.917.756c-7.727,6.365-13.83,11.394-21.135,15.3a64.979,64.979,0,0,1-15.419,5.821c-29.465,7.184-59.388,13.844-88.936,19.8-57.385,11.57-116.281,21.115-175.054,28.368A2269.112,2269.112,0,0,1,447.37,674.141ZM311.138,254.3a3.509,3.509,0,0,0-.539.037c-58.192,9.419-106.869,46.5-133.544,101.745a217.623,217.623,0,0,0-14.6,40,259.188,259.188,0,0,0-.941,122.681,221.622,221.622,0,0,0,25.123,63c17.288,28.889,39.944,51.654,65.518,65.836,36.614,20.308,76.176,21.729,114.436,23.1A2266.341,2266.341,0,0,0,724.911,655.1c58.734-7.249,117.593-16.787,174.94-28.35,29.528-5.948,59.43-12.6,88.875-19.783a63.356,63.356,0,0,0,15.047-5.679c7.157-3.826,13.2-8.807,20.855-15.111l.917-.755c.67-.554,1.329-1.146,1.958-1.761l.181-.189c6.289-6.339,8.735-14.7,6.71-22.944h0c-1.139-4.646-2.432-9.24-3.844-13.655-23.69-74.746-84.974-127.569-152.5-131.447l-1.707-.09c-55.232-2.479-103.564-9.344-147.752-20.99-52.75-13.9-98.8-34.83-136.876-62.2-90.242-64.862-185.613-92.049-275.811-78.626a15.471,15.471,0,0,0-2.479.643l-.623.174a9.376,9.376,0,0,1-1.062-.013c-.208-.011-.41-.021-.607-.021Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_126",
    "data-name": "Trac\\xE9 126",
    d: "M432.2,371.915c-2.5-2.4-5.053-15.762-8.242-17.118,2.384,5.269.653,6.663.64,12.446a39.121,39.121,0,0,1-1.141,9.745H369.435V334.825a28.847,28.847,0,0,1,28.848-28.848,17.215,17.215,0,0,1,4.275.626,27.429,27.429,0,0,1,19.351,19.4C426.028,341.061,432.578,366.119,432.2,371.915Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_127",
    "data-name": "Trac\\xE9 127",
    d: "M372.605,423.782l.027-32.863-19.318,1.726,6.818,20.726-3.191,52.1a8.173,8.173,0,1,0,9.89,6.889Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_128",
    "data-name": "Trac\\xE9 128",
    d: "M257.746,432.76h7.8l3.713-30.1H257.744Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_129",
    "data-name": "Trac\\xE9 129",
    d: "M407.978,654.769l12.337-.736v5.286l11.729,8.1a3.3,3.3,0,0,1-1.876,6.019H415.481l-2.532-5.228-.988,5.228h-5.538Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_130",
    "data-name": "Trac\\xE9 130",
    d: "M212.62,432.76h7.805l3.712-30.1H212.619Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_131",
    "data-name": "Trac\\xE9 131",
    d: "M362.853,654.769l12.337-.736v5.286l11.729,8.1a3.3,3.3,0,0,1-1.876,6.019H370.355l-2.532-5.228-.988,5.228H361.3Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_132",
    "data-name": "Trac\\xE9 132",
    d: "M403.672,355.43l-16.167.317-11.412,12.046-9.149,1.342a18.266,18.266,0,0,0-15.577,16.9h0l1.585,8.706h9.51l5.5,32.3c-2.139,5.451-2.285,9.754,2.107,11.444L383.7,464.163l40.26-18.069c2.042-3.51,2.7-7.036.609-10.464l2.878-49.45h9.677c0-9.249-3.128-17.046-12.32-18.075a108.656,108.656,0,0,0-10.989-.629Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_133",
    "data-name": "Trac\\xE9 133",
    d: "M423.96,446.094s-39.309,6.974-53.891-7.608c0,0-1.48,2.513-3.711,6.682-.642,1.2-1.881,2.011-2.629,3.463-.68,1.32-2.429,2.942-3.17,4.439-.6,1.2.36,2.777-.26,4.078-7.468,15.664-16.193,37.759-14.322,52.348,1.206,9.409,3.7,31.3,6.322,54.816.2,1.837-1.455,4.2-1.249,6.049.194,1.746,2.255,2.984,2.45,4.734.129,1.162-1.31,2.348-1.181,3.508.141,1.273,1.85,2.522,1.991,3.79,3.594,32.468,6.886,62.781,6.886,62.781h18.386l3.469-69.232-2.835-25.236,6.657-51.038,9.193,48.5,1.183,27.3,9.715,70.975h17V577.734l1.268-3.569-1.268-4.578,1.268-4.932-1.268-5.372Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_134",
    "data-name": "Trac\\xE9 134",
    d: "M408.634,346.055a18.326,18.326,0,1,1,3.175-15.314c.053.22.1.438.14.665A18.3,18.3,0,0,1,408.634,346.055Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_135",
    "data-name": "Trac\\xE9 135",
    d: "M404.813,335.6a9.633,9.633,0,0,0-2.815-5.1,13.142,13.142,0,0,1-.761,5.51,25.4,25.4,0,0,1-13.955-2.764c-3.233-2.194-7.348-2-12.141,0A17.751,17.751,0,0,1,392.9,315.487h3.168a17.755,17.755,0,0,1,17.752,17.749A52.851,52.851,0,0,1,404.813,335.6Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 51,
    cy: 51,
    r: 51,
    transform: "translate(62.249 234)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 51,
    cy: 51,
    r: 51,
    transform: "translate(387.249)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 51,
    cy: 51,
    r: 51,
    transform: "translate(792.249 242)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_136",
    "data-name": "Trac\\xE9 136",
    d: "M683.125,282.421V398.067a9.119,9.119,0,0,1-9.025,9.119.807.807,0,0,1-.1,0h-13.46a40.607,40.607,0,0,1-40.607-40.607V282.421a9.123,9.123,0,0,1,9.123-9.123h5.454c-2.527,7.371,31.765,10.474,33.648,0H674A9.123,9.123,0,0,1,683.125,282.421Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_137",
    "data-name": "Trac\\xE9 137",
    d: "M643.182,264.65a1.2,1.2,0,0,1,1.2-1.2h8.13a1.2,1.2,0,1,1,0,2.391h-8.13a1.2,1.2,0,0,1-1.2-1.2Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_138",
    "data-name": "Trac\\xE9 138",
    d: "M676.794,421.859H625.378a15.063,15.063,0,0,1-15.046-15.046V325.972a2.186,2.186,0,0,1-.911-1.779v-8.13a2.186,2.186,0,0,1,.911-1.778V312.1a2.186,2.186,0,0,1-.911-1.778v-8.131a2.186,2.186,0,0,1,.911-1.778v-3.944a2.184,2.184,0,0,1-1.15-1.93v-8.13a2.184,2.184,0,0,1,1.15-1.93V273.674a15.063,15.063,0,0,1,15.046-15.046h51.416a15.063,15.063,0,0,1,15.046,15.046V297.23a1.886,1.886,0,0,1,.886,1.6v15.5a1.887,1.887,0,0,1-.886,1.6v90.883A15.063,15.063,0,0,1,676.794,421.859ZM625.378,260.628a13.061,13.061,0,0,0-13.046,13.046v12.508l-.962.037a.2.2,0,0,0-.188.192v8.13a.2.2,0,0,0,.188.192l.962.037v7.049l-.761.188a.2.2,0,0,0-.15.187v8.131a.2.2,0,0,0,.15.187l.761.188v4.991l-.761.188a.2.2,0,0,0-.15.187v8.13a.2.2,0,0,0,.15.187l.761.188v82.246a13.061,13.061,0,0,0,13.046,13.046h51.416a13.061,13.061,0,0,0,13.046-13.046v-92.6h.886V298.942h-.886V273.674a13.061,13.061,0,0,0-13.046-13.046Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 1.196,
    cy: 1.196,
    r: 1.196,
    transform: "translate(502.98 37.595)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_139",
    "data-name": "Trac\\xE9 139",
    d: "M396.956,496.262H263.168a7.188,7.188,0,0,1-7.17-7.169V423.9a7.188,7.188,0,0,1,7.169-7.17H396.955a7.188,7.188,0,0,1,7.17,7.169v65.189a7.188,7.188,0,0,1-7.169,7.17Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_140",
    "data-name": "Trac\\xE9 140",
    d: "M396.956,496.262H263.168a7.188,7.188,0,0,1-7.17-7.169V423.9a7.188,7.188,0,0,1,7.169-7.17H396.955a7.188,7.188,0,0,1,7.17,7.169v65.189a7.188,7.188,0,0,1-7.169,7.17ZM263.168,418.734A5.185,5.185,0,0,0,258,423.9v65.187a5.185,5.185,0,0,0,5.171,5.17H396.954a5.185,5.185,0,0,0,5.171-5.171V423.9a5.185,5.185,0,0,0-5.171-5.17Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_141",
    "data-name": "Trac\\xE9 141",
    d: "M337.232,486.628c-26.386,0-53.9-.252-64.164-.416a5.176,5.176,0,0,1-5.07-5.155V427.1a1.83,1.83,0,0,1,1.823-1.828H390.3a1.829,1.829,0,0,1,1.827,1.823V463.7a22.842,22.842,0,0,1-22.457,22.752C360.1,486.579,348.771,486.628,337.232,486.628Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_142",
    "data-name": "Trac\\xE9 142",
    d: "M383.146,460.339H274.287a4.439,4.439,0,0,1-4.164-2.936L257.8,422.837a4.423,4.423,0,0,1,4.158-5.907l136.072-.189a4.423,4.423,0,0,1,4.359,5.2l.105.044-.391.912,0,.009-14.895,34.755a4.41,4.41,0,0,1-4.06,2.68Zm14.892-41.6-136.075.189a2.423,2.423,0,0,0-2.278,3.235l12.321,34.565a2.434,2.434,0,0,0,2.282,1.608H383.146a2.413,2.413,0,0,0,2.222-1.467l14.9-34.756.732.314-.732-.314a2.421,2.421,0,0,0-2.226-3.375Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 8.524,
    cy: 8.524,
    r: 8.524,
    transform: "translate(168.459 224.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 8.524,
    cy: 8.524,
    r: 8.524,
    transform: "translate(490.459 150.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143",
    "data-name": "Trac\\xE9 143",
    d: "M974.255,508.979l-22.77-22.48a11.884,11.884,0,0,0-8.43-3.46h-.08a11.914,11.914,0,0,0-8.46,3.56,27.991,27.991,0,0,0-.49,38.84c.24.26.49.51.74.76a27.249,27.249,0,0,0,4.56,3.65,27.677,27.677,0,0,0,15.11,4.43h.17a27.826,27.826,0,0,0,19.75-8.32,12.023,12.023,0,0,0-.1-16.98Zm-1.32,15.57a26.092,26.092,0,0,1-32.76,3.48,26.783,26.783,0,0,1-4.01-3.25,26,26,0,0,1-.23-36.77,9.913,9.913,0,0,1,7.06-2.97h.06a9.911,9.911,0,0,1,7.02,2.88l22.77,22.49a10.007,10.007,0,0,1,.09,14.14Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_144",
    "data-name": "Trac\\xE9 144",
    d: "M899.544,435.2l-22.77-22.49a11.927,11.927,0,0,0-8.43-3.46h-.07a11.947,11.947,0,0,0-8.47,3.57,28.077,28.077,0,0,0-4.72,33l.01.01a27.558,27.558,0,0,0,4.33,5.93c.19.22.41.44.63.66a27.835,27.835,0,0,0,19.67,8.08h.18a27.854,27.854,0,0,0,19.75-8.33A12,12,0,0,0,899.544,435.2Zm-1.32,15.57a25.856,25.856,0,0,1-18.33,7.73h-.17a26,26,0,0,1-18.49-44.27,10.008,10.008,0,0,1,14.14-.09l22.77,22.48a10.019,10.019,0,0,1,.08,14.15Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_145",
    "data-name": "Trac\\xE9 145",
    d: "M975.71,516.047l-25.1-24.794a8.727,8.727,0,0,0-12.327.077,22,22,0,1,0,31.305,30.919Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_146",
    "data-name": "Trac\\xE9 146",
    d: "M901,442.262l-25.1-24.794a8.727,8.727,0,0,0-12.327.077,22,22,0,1,0,31.305,30.919Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_147",
    "data-name": "Trac\\xE9 147",
    d: "M948.125,531.489l-.6,1.58q-4.23-1.6-8.2-3.22c-46.88-19.13-69.26-41.52-84.23-84.02l-.01-.01q-1.065-3-2.07-6.14l1.58-.51a25.538,25.538,0,0,0,2.3,5.78q1.23,3.495,2.53,6.81c14.07,35.87,34.82,56.37,74.6,73.68q3,1.305,6.15,2.59a26.088,26.088,0,0,0,7.95,3.46Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 2.001,
    height: 73,
    transform: "translate(722.078 234.241) rotate(-45.355)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_148",
    "data-name": "Trac\\xE9 148",
    d: "M436.64,416.173l.027-32.863-19.318,1.726,6.818,20.726L399.42,443.278a8.173,8.173,0,1,0,9.89,6.889Z",
    transform: "translate(-152.875 -225.859)",
    fill: "#ffb6b6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcons);
export default __webpack_public_path__ + "static/media/contact-icons.1a0934884621d5da3663f18b38aa081e.svg";
export { ForwardRef as ReactComponent };